import { render, staticRenderFns } from "./ZnTemplate.vue?vue&type=template&id=56ec78ee"
import script from "./ZnTemplate.vue?vue&type=script&lang=js"
export * from "./ZnTemplate.vue?vue&type=script&lang=js"
import style0 from "./ZnTemplate.vue?vue&type=style&index=0&id=56ec78ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports